import { SVGProps } from "react";

const Singapore = (props: SVGProps<SVGSVGElement>) => {
  const { width = 24, height = 24 } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
        fill="#F8F9F9"
      />
      <path
        d="M2 12C2 6.47719 6.47719 2 12 2C17.5228 2 22 6.47719 22 12"
        fill="#D80027"
      />
      <path
        d="M8.08709 7.21727C8.08709 5.76031 9.11103 4.5432 10.4784 4.24457C10.2682 4.19871 10.0502 4.17383 9.82619 4.17383C8.14529 4.17383 6.78271 5.53641 6.78271 7.2173C6.78271 8.8982 8.14529 10.2608 9.82619 10.2608C10.0501 10.2608 10.2682 10.2359 10.4784 10.19C9.11103 9.89137 8.08709 8.67426 8.08709 7.21727Z"
        fill="#F8F9F9"
      />
      <path
        d="M12.0002 4.39136L12.2161 5.05562H12.9146L12.3495 5.4662L12.5653 6.13046L12.0002 5.71995L11.4352 6.13046L11.651 5.4662L11.0859 5.05562H11.7844L12.0002 4.39136Z"
        fill="#F8F9F9"
      />
      <path
        d="M10.306 5.69556L10.5218 6.35985H11.2203L10.6552 6.7704L10.8711 7.43466L10.306 7.02415L9.74082 7.43466L9.95672 6.7704L9.3916 6.35985H10.0901L10.306 5.69556Z"
        fill="#F8F9F9"
      />
      <path
        d="M13.6946 5.69556L13.9105 6.35985H14.6089L14.0438 6.7704L14.2597 7.43466L13.6946 7.02415L13.1295 7.43466L13.3454 6.7704L12.7803 6.35985H13.4787L13.6946 5.69556Z"
        fill="#F8F9F9"
      />
      <path
        d="M13.0422 7.6521L13.2581 8.3164H13.9565L13.3914 8.72694L13.6073 9.3912L13.0422 8.98069L12.4771 9.3912L12.693 8.72694L12.1279 8.3164H12.8263L13.0422 7.6521Z"
        fill="#F8F9F9"
      />
      <path
        d="M10.958 7.6521L11.1738 8.3164H11.8723L11.3072 8.72694L11.5231 9.3912L10.958 8.98069L10.3929 9.3912L10.6087 8.72694L10.0436 8.3164H10.7421L10.958 7.6521Z"
        fill="#F8F9F9"
      />
    </svg>
  );
};

export default Singapore;
